import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Cooling() {
  const [coolers, setCoolers] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // Фильтруем по категории "cooling"
        const coolingItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'cooling'
        );

        setCoolers(coolingItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="cooling">
      <h1>Системы охлаждения</h1>
      <div className="cooling__list">
        {coolers.length > 0 ? (
          coolers.map((cooler) => (
            <div key={cooler.id} className="cooling__card">
              <img src={cooler.image} alt={cooler.name} />
              <h2>{cooler.name}</h2>
              <p className="specs">{cooler.description}</p>
              <p className="price">{cooler.price}</p>
              <Link to={`/components/cooling/${cooler.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
